// extracted by mini-css-extract-plugin
module.exports = {"Label":"CheckboxLabel_Label__3s3vP"};